// extracted by mini-css-extract-plugin
module.exports = {"deadline":"category_deadline__pGsef"};